import { FC } from 'react'
import { LinkStyleForm } from './LinkStyleForm'
import { LinkStyleToggle } from './LinkStyleToggle'
import { LinkStyle as LinkStyleTypes } from '../../../../constants/customizeTheme'
import { LinkThemeState } from './types'
import { Stack } from '@dtx-company/design-system/src'
import { useFlowpageTheme } from '../../../../components/profile/Customize/hooks'
import events from '@dtx-company/inter-app/src/event-tracking/events/flowpage'

/**
 * Renders a toggle that unfolds a customization form to change link color,
 * link text color and  link text size
 */
export const LinkStyle: FC<LinkThemeState> = ({
  linkTheme,
  hiddenFields,
  setLinkTheme,
  disabled
}) => {
  const { theme: pageTheme } = useFlowpageTheme()
  const isLinkStyleInset = pageTheme?.linkStyle === LinkStyleTypes.INSET
  return (
    <Stack data-testid="link-style-form-container" direction="column" gap={4}>
      <LinkStyleToggle
        checked={Boolean(linkTheme?.active)}
        onChange={checked => {
          events.Flowpage_PageProfile_Toggled_Link_Level_Advanced_Customization(
            checked ? 'on' : 'off'
          )
          setLinkTheme({ active: checked })
        }}
        disabled={disabled}
      />
      {Boolean(linkTheme?.active) && (
        <LinkStyleForm
          hiddenFields={{
            ...hiddenFields,
            shadowColor: isLinkStyleInset ? undefined : hiddenFields?.shadowColor,
            borderColor: isLinkStyleInset ? undefined : hiddenFields?.borderColor
          }}
          linkTheme={linkTheme}
          setLinkTheme={setLinkTheme}
          disabled={disabled}
        />
      )}
    </Stack>
  )
}
